import { accommodationReservation } from './accommodationReservation';
import { activityReservationTable } from './activityReservationTable';
import { groupActivityReservationTable } from './groupActivityReservationTable';

export const subViews = {
  groupBooking: accommodationReservation,
  groupAccommodationReservation: accommodationReservation,
  groupActivityReservation: groupActivityReservationTable,
  activityReservation: activityReservationTable,
};
